import { Injectable, inject } from '@angular/core';
import { ENVIRONMENT, EnvironmentConfig } from '@ct/model';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable()
export class AppInsightsService {
  private disabled: boolean;
  appInsights: ApplicationInsights;

  constructor() {
    const env = inject<EnvironmentConfig>(ENVIRONMENT);

    if (!env.APPINSIGHTS_CONNECTION_STRING) {
      this.disabled = true;
      console.error(`No connection string, disabling application insights`);
    } else {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: env.APPINSIGHTS_CONNECTION_STRING,
          enableAutoRouteTracking: true,
        },
      });
      this.appInsights.loadAppInsights();
      this.appInsights.trackPageView();
    }
  }

  setAuthenticatedUser(username: string) {
    this.appInsights?.setAuthenticatedUserContext(username);
  }

  logPageView(name?: string, url?: string) {
    // option to call manually
    this.appInsights?.trackPageView({
      name,
      uri: url,
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights?.trackEvent({ name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights?.trackMetric({ name, average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights?.trackException({ exception, severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights?.trackTrace({ message }, properties);
  }
}
